import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import Landing from "@/pages/Landing";
import Configurator from "@/pages/Configurator";
import Quotes from "@/pages/Quotes";
import QuoteDetail from "@/pages/QuoteDetail";
import Embed from "@/pages/Embed";
import Integration from "@/pages/Integration";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminDashboard from "@/pages/AdminDashboard";
import Navbar from "@/components/Navbar";
import ProtectedRoute from "@/components/ProtectedRoute";
import ErrorBoundary from "@/components/ErrorBoundary";
import Account from "@/pages/Account";

function Chrome({ children }) {
  const { pathname } = useLocation();
  const hideNav = pathname.startsWith("/embed");
  return (
    <>
      {!hideNav && <Navbar />}
      {children}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
        <AuthProvider>
          <Chrome>
            <ErrorBoundary>
              <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/embed" element={<Embed />} />
              <Route
                path="/configurateur"
                element={
                  <ProtectedRoute>
                    <Configurator />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/devis"
                element={
                  <ProtectedRoute>
                    <Quotes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/devis/:id"
                element={
                  <ProtectedRoute>
                    <QuoteDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/mon-compte"
                element={
                  <ProtectedRoute>
                    <Account />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute admin>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/integration"
                element={
                  <ProtectedRoute admin>
                    <Integration />
                  </ProtectedRoute>
                }
              />
            </Routes>
            </ErrorBoundary>
          </Chrome>
          <Toaster position="top-right" richColors />
        </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
